import { BULK_UPDATE_COUPON_NOTIF_TYPE } from '@Saral-Influencer-Marketing/saral-utils/src/constants/notification';

import {
  SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES,
  SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPE_VALUES,
  SathiBulkActionCompletedNotificationType,
} from './constants/sathiBulkActions';

export type SathiBulkActionInfluencer = {
  affiliateId?: string;
  influencerId?: string;
  name?: string;
  username?: string;
  profileImg?: string;
  listId?: string;
};

export type SathiBulkActionNotificationContent = {
  icon?: string;
  body?: string;
  actionType?: string;
  tierName?: string;
  successCount?: number;
  updatedCount?: number;
  failedCount?: number;
  influencers?: SathiBulkActionInfluencer[];
  listId?: string;
};

export type SathiBulkActionNotification = {
  type?: string;
  title?: string;
  content?: SathiBulkActionNotificationContent;
};

export type SathiBulkActionNotificationDisplay = {
  title: string;
  bodyLines: string[];
  icon: string;
};

const getInfluencerCount = (content?: SathiBulkActionNotificationContent) =>
  content?.successCount ?? content?.updatedCount ?? content?.influencers?.length ?? 0;

export const isSathiBulkActionCompletedNotification = (notification: SathiBulkActionNotification) => {
  if (notification?.type !== BULK_UPDATE_COUPON_NOTIF_TYPE) {
    return false;
  }

  const actionType = notification?.content?.actionType;
  return SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPE_VALUES.includes(
    actionType as SathiBulkActionCompletedNotificationType
  );
};

export const getSathiBulkActionNotificationListId = (notification: SathiBulkActionNotification) => {
  return notification?.content?.listId ?? notification?.content?.influencers?.[0]?.listId ?? null;
};

export const getSathiBulkActionNotificationDisplay = (
  notification: SathiBulkActionNotification
): SathiBulkActionNotificationDisplay => {
  const { content } = notification;
  const actionType = content?.actionType;
  const count = getInfluencerCount(content);
  const tierName = content?.tierName ?? 'the selected tier';

  switch (actionType) {
    case SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES.COMMISSION_TIERS_UPDATED:
      return {
        title: 'Commission Tiers Updated!',
        bodyLines: [`${count} Influencers are moved to`, tierName],
        icon: '🔗',
      };
    case SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES.DISCOUNT_CODES_UPDATED:
      return {
        title: 'Discount Codes Updated!',
        bodyLines: [`Updated discount codes for ${count} Influencers`],
        icon: '🏷️',
      };
    case SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES.DISCOUNT_CODES_CREATED:
      return {
        title: 'Discount Codes Created!',
        bodyLines: [`Discount Codes are created for ${count} Influencers`],
        icon: '🏷️',
      };
    case SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES.SHIP_FREE_PRODUCT_COMPLETED:
      return {
        title: 'Gifts on their way!',
        bodyLines: [`Orders have been placed for ${count} Influencers`],
        icon: '🚛',
      };
    default:
      return {
        title: notification?.title ?? 'Bulk action completed',
        bodyLines: content?.body ? [content.body] : [],
        icon: content?.icon ?? '⏳',
      };
  }
};
